/**
 * The marks the agent lays over existing content: a circle round an answer, a
 * highlighter band, a tick. Keyed on the gateway's `intent` rather than
 * `meta.role === "agent"`, which is also true of the worked example and the
 * problem statement.
 */

/** Persisted in canvas snapshots; treat as fixed, like `AUTHORED_SOURCE`. */
export const ANNOTATION_META_KEY = "annotation";

/** True for an action that draws commentary over existing content. */
export function isAnnotationAction(action: { intent?: string }): boolean {
  const intent = action.intent;
  if (typeof intent !== "string") return false;
  // The right-angle marker is the one commentary verb outside `annotate.*`.
  return intent.startsWith("annotate.") || intent === "mark_right_angle";
}

/** True for a shape carrying the annotation tag. */
export function isAnnotationShape(shape: {
  meta?: Record<string, unknown>;
}): boolean {
  return shape.meta?.[ANNOTATION_META_KEY] === true;
}

/** Absent rather than `false` for content — the flag is persisted. */
export function annotationMeta(action: {
  intent?: string;
}): Record<string, true> {
  return isAnnotationAction(action) ? { [ANNOTATION_META_KEY]: true } : {};
}
